import { log } from './logger';

export const searchConversions = (searchTerm, conversionData) => {
  log('Searching for:', searchTerm);
  log('Available conversion data:', conversionData);
  
  if (!searchTerm || searchTerm.length < 2) return [];
  
  const searchLower = searchTerm.toLowerCase();
  const results = [];

  // Search through all conversion types
  Object.entries(conversionData).forEach(([category, data]) => {
    const units = data.units || [];
    
    // Create all possible conversion pairs
    units.forEach((fromUnit) => {
      units.forEach((toUnit) => {
        if (fromUnit !== toUnit) {
          // Check if search term matches category or units
          if (
            category.toLowerCase().includes(searchLower) ||
            fromUnit.toLowerCase().includes(searchLower) ||
            toUnit.toLowerCase().includes(searchLower)
          ) {
            results.push({
              category,
              categoryName: data.name,
              from: fromUnit,
              to: toUnit,
              label: `${fromUnit} to ${toUnit}`,
              description: `Convert ${fromUnit} to ${toUnit} in ${data.name}`
            });
          }
        }
      });
    });
  });

  log('Search results:', results);
  return results.slice(0, 8);
}; 